export default {
  message(state) {
    return state.message;
  },
  getPeonList(state) {
    return state.peonList;
  },
  getPeon(state) {
    return function (deviceId) {
      for (var i = 0; i < state.peonList.length; i++) {
        if (state.peonList[i].deviceId === deviceId) {
          return state.peonList[i];
        }
      }

      return null;
    };
  },
  getPeonAlias(state) {
    return function (deviceId) {
      for (var i = 0; i < state.peonList.length; i++) {
        if (state.peonList[i].deviceId === deviceId) {
          return state.peonList[i].alias;
        }
      }

      return "";
    };
  },
  isPeonLaterThan(state, getters) {
    return function (deviceId, baseVersion) {
      if (deviceId == null || baseVersion == null) {
        return false;
      }

      var { version } = getters.getPeon(deviceId);

      // version 값도 없는 옛날 버전이면 무조건 false
      if (version == null) {
        return false;
      }

      // 귀찮아서 그냥 문자열 비교해버림 (2.10.0 과 같이 두자리 숫자가 들어가면 어떻게 될지 안해봐서 모름 ㅋ)
      if (version.localeCompare(baseVersion) >= 0) {
        return true;
      }

      return false;
    };
  },
  getNotification(state) {
    return function (deviceId) {
      var notification = state.notificationMap[deviceId];
      // if (notification === undefined || notification === null) {
      //     return "-";
      // }

      return notification;
    };
  },
  getNotificationList(state) {
      return state.notificationList;
  },
  getTotalNotification(state) {
    return state.totalNotification;
  },
  getTotalAlarm(state) {
    return state.totalAlarm;
  },
  getTotalNormalNotification(state) {
    return state.totalNormalNotification;
  },
  getTotalUnconfirmedAlarmCount(state) {
    return state.totalUnconfirmedAlarmCount;
  },
  getTotalUnconfirmedAlarm(state) {
    return state.totalUnconfirmedAlarm;
  },
  getUserList(state) {
    return state.userList;
  },
  getPropertyList(state) {
    return state.propertyList;
  },
  getAuthorityList(state) {
    //=> 20221102 authorityList 추가
    return state.authorityList;
  },
  getKakaoUserList(state) {
    //=> 20230321 kakaoUserList 추가
    return state.kakaoUserList;
  }
};
